export const EU_EEA_COUNTRY_CODES = new Set([
  // EU member states
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
  'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  // EEA
  'IS', 'LI', 'NO',
  // UK (UK GDPR)
  'GB',
]);

export function isEUCountry(code: string | null): boolean {
  if (!code) return false;
  return EU_EEA_COUNTRY_CODES.has(code.toUpperCase());
}

export const GEO_COOKIE_NAME = 'geo-eu';
